import React, { useState } from "react";
import { useBusinessRules } from "./hooks/useBusinessRules";
import BusinessRulesSidebar from "./components/BusinessRulesSidebar";
import BusinessRulesDetail from "./components/BusinessRulesDetail";
import { MasterDetailLayout, ContentLoader, Breadcrumb } from "../../../components/Common";
import { BUSINESS_RULES_CATEGORIES } from "../../../models/businessRule";

/**
 * BusinessRulesPage
 * Rota: /settings/business-rules
 * Layout Master-Detail: Sidebar com categorias + Painel com regras configuráveis.
 */
const BusinessRulesPage = () => {
    document.title = "Regras de Negócio | NeoApp";

    const [activeCategoryId, setActiveCategoryId] = useState(BUSINESS_RULES_CATEGORIES[0]?.id || "");

    const {
        rules,
        isLoading,
        isSaving,
        saveRules,
        isReady,
    } = useBusinessRules();

    if (!isReady) {
        return <ContentLoader message="Carregando Regras de Negócio..." />;
    }

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Regras de Negócio" />
            </div>
            
            <div className="border-top mb-3"></div>
            <MasterDetailLayout
                master={
                    <BusinessRulesSidebar
                        activeCategoryId={activeCategoryId}
                        onSelectCategory={setActiveCategoryId}
                        loading={isLoading}
                    />
                }
                detail={
                    <BusinessRulesDetail
                        categoryId={activeCategoryId}
                        rules={rules}
                        onSave={saveRules}
                        isSaving={isSaving}
                    />
                }
            />
        </React.Fragment>
    );
};

export default BusinessRulesPage;
